// ============================================================================
// FILE: src/components/SceneLayers/Connectors/ConnectorArrow.tsx
// ============================================================================

import { useTheme } from '@mui/material';

interface ModernArrowProps {
  x: number;
  y: number;
  rotation: number;
  color?: string;
  size?: number;
}

export const ModernArrow = ({
  x,
  y,
  rotation,
  color,
  size = 1
}: ModernArrowProps) => {
  const theme = useTheme();
  const arrowColor = color || theme.palette.common.black;
  const outlineColor = theme.palette.background.paper;

  
  return (
    <g transform={`translate(${x}, ${y})`} style={{ pointerEvents: 'none' }}>
      <g transform={`rotate(${rotation}) scale(${size})`}>
        {/* A single filled arrow remains legible over detailed isometric icons. */}
        <path
          d="M 0,-15 L 10,6 L 0,2 L -10,6 Z"
          fill={arrowColor}
          stroke={outlineColor}
          strokeWidth={3}
          strokeLinejoin="round"
          paintOrder="stroke fill"
          style={{ filter: 'drop-shadow(0 2px 3px rgba(15, 23, 42, 0.45))' }}
        />
      </g>
    </g>
  );
};
